<div class="mb-8 px-3">

  <!-- Page Header -->
  <div class="mb-8 grid grid-cols-1 gap-4 lg:grid-cols-7">
    <div class="lg:col-span-4">
      <div class="w-full rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3 sm:w-fit">
        <div class="border-l-4 border-gray-800 pl-4">
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
            Manage Preview
          </p>

          <h2 class="mt-1 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
            Instagram Photo Post
          </h2>
        </div>
      </div>
    </div>

    <div class="flex items-start justify-start lg:col-span-3 lg:justify-end">
      <a
        routerLink="/manage-preview"
        class="inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition hover:border-gray-400 hover:bg-gray-50 hover:text-gray-900"
      >
        Back
      </a>
    </div>
  </div>

  <!-- Loading State -->
  <div
    *ngIf="loading"
    class="mx-auto max-w-5xl rounded-2xl border border-gray-300 bg-white p-10 text-center"
  >
    <div class="mx-auto mb-4 h-10 w-10 rounded-full border-4 border-gray-200 border-t-gray-800"></div>

    <p class="text-sm font-medium text-gray-700">
      Loading Instagram preview...
    </p>

    <p class="mt-1 text-xs text-gray-400">
      Please wait while the post content is being prepared.
    </p>
  </div>

  <!-- Error State -->
  <div
    *ngIf="errorMessage && !loading"
    class="mx-auto max-w-5xl rounded-2xl border border-red-200 bg-red-50 p-6"
  >
    <div class="grid grid-cols-1 gap-3 md:grid-cols-12 md:items-center">
      <div class="md:col-span-10">
        <p class="text-sm font-semibold text-red-800">
          Unable to load preview
        </p>

        <p class="mt-1 text-sm text-red-700">
          {{ errorMessage }}
        </p>
      </div>

      <div class="md:col-span-2 md:text-right">
        <a
          routerLink="/manage-preview"
          class="inline-flex items-center justify-center rounded-xl border border-red-200 bg-white px-4 py-2 text-sm font-medium text-red-700 transition hover:bg-red-100"
        >
          Go back
        </a>
      </div>
    </div>
  </div>

  <!-- Instagram Preview Layout -->
  <div
    *ngIf="!loading && !errorMessage"
    class="mx-auto grid w-full max-w-7xl grid-cols-1 items-start gap-6 xl:grid-cols-[minmax(0,1fr)_380px] xl:gap-10"
  >

    <!-- Preview Column -->
    <div class="relative w-full max-w-6xl justify-self-center xl:justify-self-start">

      <!-- Floating Desktop Actions -->
      <div class="absolute top-4 z-20 hidden -left-14 flex-col items-center rounded-3xl border border-gray-300 bg-white/95 px-2 py-3 backdrop-blur-md xl:flex 2xl:-left-20">

        <app-manage-preview-action-button
          icon="arrow_back"
          tooltip="Back"
          buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
          (actionClick)="goBack()"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="edit"
          tooltip="Edit"
          [disabled]="true"
          buttonClass="my-1 bg-slate-100 text-slate-400"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="replay"
          tooltip="Reuse"
          buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
          (actionClick)="reusePost()"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="delete_outline"
          tooltip="Delete"
          tooltipPosition="left"
          [disabled]="true"
          buttonClass="my-1 bg-slate-100 text-slate-400"
        ></app-manage-preview-action-button>

        <div class="my-3 h-px w-8 bg-slate-200"></div>

        <app-manage-preview-action-button
          icon="skip_previous"
          tooltip="Previous"
          buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
          (actionClick)="goToPreviousPost()"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="skip_next"
          tooltip="Next"
          buttonClass="my-1 bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950 focus:outline-none focus:ring-2 focus:ring-blue-100"
          (actionClick)="goToNextPost()"
        ></app-manage-preview-action-button>

      </div>

      <!-- Mobile / Tablet Actions -->
      <div class="mb-4 grid grid-cols-6 gap-2 rounded-3xl border border-gray-300 bg-white/95 p-3 backdrop-blur-md xl:hidden">

        <app-manage-preview-action-button
          icon="arrow_back"
          tooltip="Back"
          buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
          (actionClick)="goBack()"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="edit"
          tooltip="Edit"
          [disabled]="true"
          buttonClass="bg-slate-100 text-slate-400"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="replay"
          tooltip="Reuse"
          buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
          (actionClick)="reusePost()"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="delete_outline"
          tooltip="Delete"
          [disabled]="true"
          buttonClass="bg-slate-100 text-slate-400"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="skip_previous"
          tooltip="Previous"
          buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
          (actionClick)="goToPreviousPost()"
        ></app-manage-preview-action-button>

        <app-manage-preview-action-button
          icon="skip_next"
          tooltip="Next"
          buttonClass="bg-slate-100 text-slate-700 transition hover:bg-slate-200 hover:text-slate-950"
          (actionClick)="goToNextPost()"
        ></app-manage-preview-action-button>

      </div>

      <!-- Instagram Card -->
      <div class="instagram-card w-full font-15">
        <div class="card-body px-0">
          <div class="overflow-hidden rounded-3xl border border-gray-300 bg-white">
            <div class="grid grid-cols-1 md:grid-cols-12">

              <!-- Media Section -->
              <div class="bg-gray-50 md:col-span-7 lg:col-span-8">

                <!-- Carousel -->
                <div
                  *ngIf="!isVideo && isCarousel"
                  class="relative h-full min-h-[420px] overflow-hidden bg-black md:min-h-[560px]"
                  (mouseenter)="pauseAutoplay()"
                  (mouseleave)="resumeAutoplay()"
                >
                  <div
                    class="carousel-track flex h-full w-full"
                    [style.transform]="'translateX(-' + currentIndex * 100 + '%)'"
                  >
                    <div
                      *ngFor="let image of carouselImages"
                      class="h-full w-full flex-shrink-0"
                    >
                      <img
                        [src]="image"
                        class="instagram-main-img h-full w-full object-cover"
                        alt="Instagram carousel image"
                      />
                    </div>
                  </div>

                  <button
                    type="button"
                    class="manage-post-btn carousel-arrow absolute left-4 top-1/2 z-20 -translate-y-1/2"
                    (click)="prevSlide()"
                  >
                    <mat-icon>chevron_left</mat-icon>
                  </button>

                  <button
                    type="button"
                    class="manage-post-btn carousel-arrow absolute right-4 top-1/2 z-20 -translate-y-1/2"
                    (click)="nextSlide()"
                  >
                    <mat-icon>chevron_right</mat-icon>
                  </button>

                  <div class="absolute bottom-4 left-1/2 z-20 inline-flex -translate-x-1/2 items-center gap-1.5 rounded-full border border-white/20 bg-black/50 px-3 py-2 backdrop-blur-sm">
                    <button
                      type="button"
                      *ngFor="let image of carouselImages; let i = index"
                      class="h-1.5 w-1.5 rounded-full transition"
                      [ngClass]="i === currentIndex ? 'bg-white' : 'bg-white/50'"
                      (click)="goToSlide(i)"
                    ></button>
                  </div>
                </div>

                <!-- Normal Generated Image -->
                <div
                  *ngIf="!isVideo && !isCarousel && !isSwitchboardImage"
                  class="relative flex min-h-[420px] w-full items-center justify-center overflow-hidden border-b border-gray-300 bg-gray-100 p-4 md:min-h-[560px] md:border-b-0 md:border-r md:border-gray-300"
                >
                  <img
                    [src]="mainImageUrl"
                    alt="Instagram post image"
                    class="mx-auto block h-auto max-h-[80vh] w-full object-contain"
                  />

                  <div
                    *ngIf="postTitle"
                    class="absolute bottom-6 left-1/2 z-10 w-[calc(100%-3rem)] max-w-[520px] -translate-x-1/2 rounded-2xl border border-white/20 bg-black/35 p-5 text-center backdrop-blur-sm"
                  >
                    <h3 class="text-2xl font-bold leading-tight text-white md:text-[28px] md:leading-8">
                      {{ postTitle }}
                    </h3>

                    <div class="mx-auto my-4 h-px w-4/5 bg-red-500 opacity-90"></div>

                    <p class="text-sm font-medium text-white md:text-base">
                      This is a preview image provided by <em>Publio.ai</em>
                    </p>
                  </div>
                </div>

                <!-- Switchboard Image -->
                <div
                  *ngIf="!isVideo && !isCarousel && isSwitchboardImage"
                  class="relative flex min-h-[420px] w-full items-center justify-center overflow-hidden border-b border-gray-300 bg-gray-100 md:min-h-[560px] md:border-b-0 md:border-r md:border-gray-300"
                >
                  <img
                    [src]="mainImageUrl"
                    class="mx-auto block h-auto max-h-[80vh] w-full object-contain"
                    alt="Instagram switchboard image"
                  />
                </div>

                <!-- Video -->
                <div
                  *ngIf="isVideo"
                  class="flex min-h-[420px] items-center justify-center overflow-hidden border-b border-gray-300 bg-black md:min-h-[560px] md:border-b-0 md:border-r md:border-gray-300"
                >
                  <div class="image-container w-full">
                    <video
                      controls
                      [attr.poster]="mainImageUrl"
                      class="mx-auto w-full"
                    >
                      <source [src]="videoUrl" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>

              </div>

              <!-- Content Section -->
              <div class="relative flex min-h-[560px] w-full flex-col bg-white md:col-span-5 lg:col-span-4">

                <!-- Instagram Header -->
                <div class="border-b border-gray-300 px-4 py-4">
                  <div class="grid grid-cols-12 items-center gap-3">
                    <div class="col-span-10 flex min-w-0 items-center">
                      <img
                        [src]="thumbnailFilePath"
                        class="instagram-avatar me-3 rounded-full border border-gray-300 object-cover"
                        alt="Instagram profile"
                      />

                      <div class="min-w-0">
                        <p class="font-13 bold-600 mb-0 flex items-center gap-1 truncate text-gray-900">
                          {{ siteDomain }}
                          <span class="text-gray-400">&bull;</span>
                          <span class="blue-link font-semibold">Follow</span>
                        </p>
                      </div>
                    </div>

                    <div class="col-span-2 flex justify-end">
                      <img
                        src="assets/icons/dots.png"
                        class="dots-icon rounded-full"
                        alt="More options"
                      />
                    </div>
                  </div>
                </div>

                <!-- Post Content -->
                <div class="flex-1 px-4 py-4">
                  <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-2 sm:col-span-1 md:col-span-2">
                      <img
                        [src]="thumbnailFilePath"
                        class="instagram-avatar rounded-full border border-gray-300 object-cover"
                        alt="Instagram profile"
                      />
                    </div>

                    <div class="col-span-10 sm:col-span-11 md:col-span-10">
                      <p class="bold-600 mb-0 text-sm leading-5 text-gray-900">
                        {{ postFeed }}
                      </p>

                      <small class="text-muted mt-1 flex items-center gap-1 text-xs">
                        {{ formattedDate }}
                        <span>-</span>
                        <img
                          src="assets/icons/world.png"
                          class="world-icon rounded-full"
                          alt="Public"
                        />
                      </small>

                      <p
                        class="mt-3 text-sm leading-6 text-gray-700"
                        [attr.dir]="textDirection"
                      >
                        {{ postDescription }}
                      </p>
                    </div>
                  </div>

                  <!-- Comments Placeholder -->
                  <div class="mt-10 rounded-2xl border border-gray-300 bg-gray-50 px-4 py-6 text-center">
                    <h4 class="text-sm font-bold text-gray-900">
                      No comments yet.
                    </h4>
                  </div>
                </div>

                <!-- Engagement Footer -->
                <div class="border-t border-gray-300 px-4 py-4">
                  <div class="grid grid-cols-2 gap-4">
                    <div class="flex items-center gap-4">
                      <img
                        src="assets/icons/heart.png"
                        class="instagram-like-icon"
                        alt="Like"
                      />

                      <img
                        src="assets/icons/comment.png"
                        class="instagram-like-icon"
                        alt="Comment"
                      />

                      <img
                        src="assets/icons/send.png"
                        class="instagram-like-icon"
                        alt="Send"
                      />
                    </div>

                    <div class="flex justify-end">
                      <img
                        src="assets/icons/saved.png"
                        class="instagram-like-icon"
                        alt="Save"
                      />
                    </div>
                  </div>

                  <div class="mt-4">
                    <span class="text-sm font-bold text-gray-900"># likes</span>
                    <br />
                    <small class="text-muted text-xs"># hours before</small>
                  </div>

                  <div class="mt-5 grid grid-cols-12 items-center gap-3">
                    <div class="col-span-10 flex items-center gap-3">
                      <img
                        src="assets/icons/instagram-comment-avatar.png"
                        class="comment-avatar rounded-full border border-gray-300"
                        alt="Comment avatar"
                      />

                      <div class="text-muted font-13">
                        Add a comment...
                      </div>
                    </div>

                    <div class="col-span-2 flex justify-end">
                      <img
                        src="assets/icons/smile.png"
                        class="emoji-icon"
                        alt="Emoji"
                      />
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Right Sidebar -->
    <div class="grid w-full max-w-2xl gap-5 justify-self-center xl:max-w-none xl:justify-self-stretch">

      <!-- Latest Posts -->
      <app-manage-preview-latest-posts
        [posts]="latestPosts"
        (postClick)="openLatestPost($event)"
      ></app-manage-preview-latest-posts>

      <!-- Latest Alerts -->
      <app-manage-preview-latest-alerts
        [alerts]="latestAlerts"
        (alertClick)="openLatestPost($event)"
      ></app-manage-preview-latest-alerts>

    </div>

  </div>

</div>